<template>
  <div class="page">
    <div class="banners">
      <img src="../assets/img/about/about_banner.jpg" alt="新闻动态" />
    </div>
    <section class="news">
      <div class="news-detail">
        <div class="detail">
          <h4 v-text="detail.title" class="title"></h4>
          <p v-text="detail.created_at" class="datetime"></p>
          <div class="line"></div>
          <div v-html="detail.contents"></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "newsdetail",
  data() {
    return {
      detail: {}
    };
  },
  created() {
    let arr = location.href.split("/");
    let curr_new = arr[arr.length - 1];
    let that = this;
    this.$ajax.get("/newDetail/" + curr_new).then(function (res) {
      that.detail = res.newDetail;
      window.weixinCardTitle = that.detail.title;
      for (let article of res.tops) {
        if (article.id == res.newDetail.id) {
          window.weixinCardDetail = article.summary;
        }
      }
    }).catch(error => {
      console.log(error);
    });
    
    
  },
  mounted() {
  },
  methods: {


  },
};
</script>

<style lang="scss" scoped>
.banners {
  height: 180px;

  >img {
    height: 100%;
  }
}

// 新闻详情
.news {
  .line {
    height: .1rem;
    width: 100%;
    background: rgb(245, 245, 245);
    margin: 1rem 0;
  }

  .title {
    color: #535353 !important;
  }

  .datetime {
    color: #999 !important;
    text-indent: 0 !important;
  }

  >p {
    line-height: 1em;
    color: #999;
    margin-bottom: 28px;

  }

  .news-detail {
    .detail {
      padding: 0 1rem 1rem 1rem;

      video {
        width: 100% !important;
      }

      >h4 {
        line-height: 1.3em;
        font-weight: 700;
        color: #333;
        margin-bottom: 1rem;
      }

      p {
        font-size: .6rem !important;
        color: #535353;
        padding: 5px 0;
        line-height: 2em;
        font-family: "helvetica";
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/page/newsdetail.vue